import React, { HtmlHTMLAttributes, useEffect } from 'react'
import { Helmet } from 'react-helmet-async';
import { removeUnmanagedMetaTags } from '../utils/metaTagCleanup';

const SITE_ORIGIN =
    process.env.REACT_APP_SITE_URL ||
    (typeof window !== 'undefined'
        ? `${window.location.protocol}//${window.location.host}`
        : 'https://www.plancrafter.tech');

interface props extends HtmlHTMLAttributes<HTMLDivElement> {
    title: any;
    desc?: any;
    keywords?: any;
    image?: any;
    url?: string;
    type?: string;
    noindex?: boolean;
    structuredData?: Record<string, any>;
}

const MetaSection: React.FC<props> = ({
    title,
    desc,
    keywords,
    image,
    url,
    type,
    noindex,
    structuredData,
}) => {
    const canonical = url
        ? (url.startsWith('http') ? url : SITE_ORIGIN + url)
        : (typeof window !== 'undefined'
            ? SITE_ORIGIN + window.location.pathname
            : SITE_ORIGIN);

    useEffect(() => {
        removeUnmanagedMetaTags([
            'meta[name="description"]',
            'link[rel="canonical"]',
            'meta[property="og:type"]',
            'meta[property="og:title"]',
            'meta[property="og:description"]',
            'meta[property="og:image"]',
            'meta[property="og:url"]',
        ]);
    }, []);

    return (
        <Helmet>
            <title>{title}</title>

            <meta name="description" content={desc || ''} />
            <meta name="keywords" content={keywords || ''} />
            <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow'} />

            <link rel="canonical" href={canonical} />

            <meta property="og:title" content={title} />
            <meta property="og:description" content={desc || ''} />
            <meta property="og:image" content={image || ''} />
            <meta property="og:url" content={canonical} />
            <meta property="og:type" content={type || 'website'} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={desc || ''} />
            {image && <meta name="twitter:image" content={image} />}

            {structuredData && (
                <script type="application/ld+json" key="blog-schema">
                    {JSON.stringify(structuredData)}
                </script>
            )}
        </Helmet>
    )
}

export default MetaSection;
